import React from "react";
import { Outlet } from "react-router-dom";
import useSession from "./useSession"; // ✅ გამოვიყენოთ ჰუკი
import Navigation from "./Navigation";

const ProtectedRoutes = () => {
  const { user } = useSession(); // ✅ მომხმარებელი უკვე ვალიდირებულია

  return user ? (
    <>
      <Navigation />
      <Outlet />
    </>
  ) : null;
};

export default ProtectedRoutes;
